import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAccount } from '../../components/hooks/useAccount';
import { useActor } from '../../components/hooks/useActor';
import { PERSONA_TYPES } from '../../console/_statics/persona.statics';
import { selectDebugModeEnabled } from '../../reducers/UxReducers';
import { selectGrowthbook } from '../../store/selectors/ui-settings.selectors';
import { usePlatformLanguage } from '../../utils/hooks/usePlatformLanguage';
import { configLogger } from '../loggers';

export function useGrowthbookAttrs(user: any) {
  const actor = useActor();
  const account = useAccount();
  const region = usePlatformLanguage();

  const {
    prime_one_x_dynamic_fields,
    featureFlagsEnabled,
    new_agent_experience,
    ukEnvironmentEnabled,
    auEnvironmentEnabled,
    submissions_view,
  } = useSelector(selectGrowthbook);
  const debug_mode_enabled = useSelector(selectDebugModeEnabled);

  return useMemo(() => {
    const attrs = {
      userEmail: user.email, // stable
      wreckless_ignore: !featureFlagsEnabled,
      isCowbell: actor?.subscriberType === PERSONA_TYPES.COWBELL, // stable
      agencyId: actor?.account?.id, // unstable
      new_agent_experience,
      region, // stable
      ukEnvironmentEnabled,
      auEnvironmentEnabled,
      prime_one_x_dynamic_fields,
      submissions_view,

      accountType: account?.accountType, // unstable
      accountId: account?.id, // stable
      accountName: account?.name, // stable
      subscriberType: actor?.subscriberType, // stable

      // opt in features
      debug_mode_enabled,
    };

    configLogger.debug('useGrowthbookAttrs', attrs);

    return attrs;
  }, [
    user.email,
    featureFlagsEnabled,
    new_agent_experience,
    region,
    ukEnvironmentEnabled,
    auEnvironmentEnabled,
    prime_one_x_dynamic_fields,
    submissions_view,
    debug_mode_enabled,
    account,
    actor,
  ]);
}
